import { useSelector } from 'react-redux';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';
import { camelCaseToWords, capitalizeAllWordsInString } from 'utils/Strings';
import { SpecialField, specialFields } from '../constants';
import { useMemo } from 'react';

interface CustomField {
  key: string;
  label: string;
}

export const useOptionalFields = () => {
  const optionalPersonalFields = useSelector(
    loggedInUserSelectors.currentOrganization,
  )?.optionalUserData;

  const optionalFieldsKeys = Object.keys(optionalPersonalFields ?? {}).filter((key) => {
    return !!optionalPersonalFields?.[key];
  });

  const optionalFields = optionalFieldsKeys.reduce((acc: Record<string, CustomField>, key) => {
    if (typeof optionalPersonalFields?.[key] === 'string') {
      acc[key] = {
        key,
        label: optionalPersonalFields[key] as string,
      };
    } else {
      acc[key] = {
        key,
        label: capitalizeAllWordsInString(camelCaseToWords(key)),
      };
    }

    return acc;
  }, {});

  const regularFieldsKeys = optionalFieldsKeys.filter((key: string) => {
    return !specialFields.includes(key as SpecialField);
  });

  const memoisedValues = useMemo(() => {
    return { optionalFieldsKeys, optionalFields, regularFieldsKeys };
  }, [optionalPersonalFields]);

  return memoisedValues;
};
